
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Swiftdzireonrentpune() {



    const cardData =
    {
        keyword: ' Swift Dzire on Rent Pune',
        heading: 'Prince Cabs: Swift Dzire on Rent Pune',
        headingDescription: 'Prince Cabs offers affordable Swift Dzire on Rent in Pune, perfect for city rides, airport transfers, corporate travel, and outstation trips. Our well-maintained Swift Dzire cars are fuel-efficient, spacious, and comfortable, making them an ideal choice for budget-friendly travel. With professional chauffeurs, on-time pickups, and flexible booking options, we ensure a smooth and hassle-free journey. Experience reliability, comfort, and affordability with Prince Cabs’ trusted Swift Dzire rental service in Pune.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was the grand residence of the Peshwas of the Maratha Empire. Although much of it was destroyed in a fire in 1828, its massive gates, fortified walls, and sprawling courtyards still attract visitors. The evening light-and-sound show narrates tales of Maratha valor and intrigue. Tourists enjoy exploring the ruins and imagining its glorious past. Shaniwar Wada is a symbol of Pune’s rich heritage and cultural identity."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is an architectural marvel with deep ties to India’s freedom struggle. Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. The palace now houses a museum showcasing artifacts, photographs, and personal belongings of Gandhi. Its beautifully landscaped gardens create a peaceful retreat for visitors. Recognized as a national monument, it stands as a timeless reminder of sacrifice and history."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km from Pune, Sinhagad Fort is known for its strategic importance in Maratha history. The 1670 Battle of Sinhagad, led by Tanaji Malusare, is one of its most celebrated tales. Trekkers enjoy the scenic climb, especially during monsoon when mist and greenery cover the hills. From the summit, panoramic views of the Sahyadri ranges are breathtaking. Local food stalls serve traditional pithla-bhakri, making it both a cultural and adventurous experience."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most revered religious site, dedicated to Lord Ganesha. The idol is adorned with gold and ornaments, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also known for charitable activities that benefit the community. Easily accessible in the city center, it is a must-visit for both spiritual seekers and cultural enthusiasts."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of Pune’s highest points, offering sweeping views of the city. At the summit lies the Parvati Temple complex dedicated to Lord Shiva and Goddess Parvati. The climb of more than 100 steps is rewarded with serenity and spirituality. The Peshwa Museum nearby displays artifacts from Maratha history. Sunrises and sunsets from the hill are especially captivating. It is a favorite spot for devotees, history lovers, and nature seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars and Nandi mandapa reflect Rashtrakuta-era architecture. Despite its central location, the temple offers peace and tranquility. Devotees and tourists often visit for meditation and photography. The unfinished sanctum adds to its historical intrigue. It is a hidden heritage gem amidst Pune’s bustling cityscape."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extraordinary collection of over 20,000 artifacts compiled by Dr. Dinkar Kelkar. The exhibits include musical instruments, sculptures, everyday items, and the famous recreated Mastani Mahal. The museum reflects India’s cultural diversity and heritage craftsmanship. Both art lovers and historians find it fascinating. The three-story building itself is a heritage attraction. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is one of the world’s most renowned spiritual centers. It attracts visitors from across the globe for meditation, yoga, and wellness programs. Surrounded by lush gardens, the ashram offers a peaceful retreat from city life. The community vibe blends spirituality with cosmopolitan charm. Its modern facilities and tranquil environment make it a unique destination in Pune."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and lifestyle mall. It houses hundreds of international and Indian brands, making it a retail paradise. Entertainment includes multiplex cinemas, gaming zones, and regular live events. Food courts and fine dining restaurants add to the appeal. During festivals like Christmas and Diwali, the mall comes alive with special events. It is the go-to hub for shopping and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a popular weekend destination. It supplies water to the city and offers a scenic backdrop with surrounding hills. Families enjoy picnics, boating, and evening snacks along the lakeside. During monsoon, the lush greenery enhances its charm. Cool breezes make it an enjoyable escape year-round. It is a refreshing natural retreat for locals and tourists alike."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a serene getaway near Pune. Surrounded by forests and Sahyadri hills, it is ideal for camping, nature walks, and photography. Monsoon transforms the landscape with waterfalls and misty valleys. Eco-resorts nearby offer comfortable stays amidst nature. Trekkers and couples often choose it for a peaceful weekend. Mulshi blends adventure and relaxation in equal measure."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, located on Senapati Bapat Road, is one of Pune’s most revered temples. Dedicated to Goddess Chaturshringi, it requires climbing over 100 steps to reach the sanctum. The temple is especially vibrant during Navratri with grand decorations. Devotees from across Maharashtra visit to seek blessings. The hilltop setting also provides panoramic views of the city. It is a blend of faith and tradition."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial honors Indian soldiers who sacrificed their lives post-independence. The memorial displays tanks, weapons, and war memorabilia. A museum inside narrates stories of courage and patriotism. The evening flag retreat ceremony is a moving experience. It is both educational for children and inspiring for adults. The memorial instills pride and respect for India’s armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a botanical paradise in Pune. Managed by the Agri-Horticultural Society, it houses rare trees, colorful flower nurseries, and shaded walking paths. Families often visit for picnics and leisure. The annual flower show attracts gardening enthusiasts. With colonial-era history, it is one of Pune’s heritage gardens. It offers peace and greenery within the bustling city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, Pune’s highest hill, is a favorite spot for trekking, jogging, and cycling. The summit provides panoramic views of the entire city. It is rich in biodiversity, home to several species of birds and plants. Locals gather here for morning walks and yoga sessions. Sunrises and sunsets from Vetal Hill are mesmerizing. It serves as Pune’s green lung and a refreshing escape from urban chaos."
  }
],

"services": [
    {
        "name": "Swift Dzire Rent per km Rate",
        "description": "Check the most competitive per kilometer rates for Swift Dzire rental services from Pune. Ideal for outstation travel, our transparent pricing ensures you pay only for the distance covered."
    },
    {
        "name": "Swift Car Rent per km",
        "description": "Rent a Swift Dzire at budget-friendly per kilometer rates for smooth and reliable travel. Perfect for business trips, family outings, and weekend getaways from Pune."
    },
    {
        "name": "Swift Dzire Rent per Day",
        "description": "Enjoy fixed per day rental rates on Swift Dzire cars for full-day travel or long trips. Get maximum convenience and value with a professional driver and well-maintained vehicles."
    },
    {
        "name": "Swift per km Rate",
        "description": "Get affordable Swift per km rates for both local and intercity rides. Suitable for solo or small group travel, with no hidden charges and clean, air-conditioned cars."
    },
    {
        "name": "Swift Rent per km",
        "description": "Our Swift car rental service offers low per km charges for outstation and local travel. Choose from flexible plans and experience reliable transport with experienced drivers."
    },
    {
        "name": "Swift Dzire for Rent",
        "description": "Rent a Swift Dzire for personal, business, or outstation trips from Pune. Our rental includes fuel-efficient cars, trained chauffeurs, and comfortable seating for up to 4 passengers."
    },
    {
        "name": "Swift Dzire Car Rental",
        "description": "Our Swift Dzire car rental service in Pune offers flexible booking options, transparent pricing, and comfort for daily travel, tours, or corporate use."
    },
    {
        "name": "Swift Dzire Rent Near Me",
        "description": "Looking to rent a Swift Dzire nearby? Our citywide network ensures you get quick access to well-maintained cars and courteous drivers at affordable rates."
    },
    {
        "name": "Book a Swift Dzire Cab in Pune",
        "description": "Easily book a Swift Dzire cab in Pune for local, airport, or outstation travel. Enjoy smooth rides, on-time service, and clean vehicles with 24/7 booking support."
    },
    {
        "name": "Pune to Mumbai Dzire Cab",
        "description": "Travel from Pune to Mumbai in a Swift Dzire cab offering comfort, safety, and economical fares. Ideal for airport transfers or business trips with professional drivers."
    },
    {
        "name": "Pune to Mahabaleshwar Swift Dzire Cab",
        "description": "Book a Swift Dzire cab from Pune to Mahabaleshwar for a scenic and relaxed hill station journey. Affordable rates, clean cars, and experienced drivers for a stress-free trip."
    },
    {
        "name": "Pune to Shirdi Swift Dzire Taxi",
        "description": "Reserve your Swift Dzire taxi from Pune to Shirdi for a spiritual visit. Enjoy comfortable travel with door-to-door pickup, competitive fares, and reliable service."
    },
    {
        "name": "Dzire Car Hire for Outstation Pune",
        "description": "Hire a Swift Dzire for outstation travel from Pune with flexible plans and budget pricing. Perfect for solo travelers or small families looking for economical and smooth journeys."
    },
    {
        "name": "Affordable Swift Dzire Cab",
        "description": "Travel affordably with our Swift Dzire cab service in Pune. Ideal for local trips, airport drops, and long-distance travel with value pricing and dependable service."
    },
    {
        "name": "Luxury Dzire Cab Pune",
        "description": "Choose our luxury Dzire cab in Pune for premium comfort and top-quality service. Ideal for executives and families who prefer an elegant and smooth ride at a competitive price."
    }
],
"tableData": [
    ["Swift Dzire Rent per km Rate", "Swift Car Rent per km"],
    ["Swift Dzire Rent per Day", "Swift per km Rate"],
    ["Swift Rent per km", "Swift Dzire for Rent"],
    ["Swift Dzire Car Rental", "Swift Dzire Rent Near Me"],
    ["Book a Swift Dzire Cab in Pune", "Pune to Mumbai Dzire Cab"],
    ["Pune to Mahabaleshwar Swift Dzire Cab", "Pune to Shirdi Swift Dzire Taxi"],
    ["Dzire Car Hire for Outstation Pune", "Affordable Swift Dzire Cab"],
    ["Luxury Dzire Cab Pune", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Swift Dzire on Rent in Pune",
        "WhyChoosedescription": "Prince Cabs offers well-maintained Swift Dzire cars on rent across Pune for daily commutes, airport transfers, city travel, and outstation journeys. Known for its reliability, fuel efficiency, and compact design, Swift Dzire is the ideal sedan for individuals, small families, and business professionals seeking a cost-effective yet comfortable ride."
    },
    {
        "WhyChooseheading": "Comfortable Ride with Spacious Interiors",
        "WhyChoosedescription": "Our Swift Dzire cabs come with clean and well-kept interiors, comfortable seating for up to four passengers, and decent luggage space. Whether you're taking a short trip within Pune or heading out of town, the smooth suspension and AC-equipped cabin ensure a relaxed travel experience."
    },
    {
        "WhyChooseheading": "Experienced Drivers and Punctual Service",
        "WhyChoosedescription": "All our drivers are background-verified, trained in safe driving, and familiar with local routes and traffic. Expect on-time pickups, courteous behavior, and complete assistance throughout your ride — whether it's a quick trip or a full-day rental."
    },
    {
        "WhyChooseheading": "Flexible Rental Options for Every Need",
        "WhyChoosedescription": "We offer Swift Dzire rentals for hourly usage, full-day city travel, airport transfers, corporate needs, and outstation trips. Whether you're booking last-minute or scheduling in advance, we make the process seamless with flexible pickup/drop locations across Pune."
    },
    {
        "WhyChooseheading": "Transparent Pricing and No Hidden Charges",
        "WhyChoosedescription": "Prince Cabs ensures transparent and pocket-friendly pricing on all Swift Dzire rentals. Get upfront fare estimates including driver allowance, tolls (if applicable), and taxes. You can choose from per km rates or fixed packages based on your travel plans."
    },
    {
        "WhyChooseheading": "Clean, Sanitized & Regularly Maintained Fleet",
        "WhyChoosedescription": "Each Swift Dzire vehicle is thoroughly cleaned and sanitized before dispatch. We perform regular mechanical checks to ensure safety, reliability, and comfort — giving you peace of mind whether you're traveling for work or leisure."
    },
    {
        "WhyChooseheading": "24/7 Booking Support & Customer Assistance",
        "WhyChoosedescription": "Need a Swift Dzire urgently or at odd hours? Our booking team is available 24/7 through phone, WhatsApp, and online channels to help you reserve your cab quickly and address any queries or special requirements."
    }
]
























    }

const faqData = [
    {
        question: 'Can I rent a Swift Dzire in Pune with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers Swift Dzire on rent in Pune for local travel, airport transfers, and outstation trips with flexible rental options.',
    },
    {
        question: 'What are the common uses for renting a Swift Dzire in Pune?',
        answer: 'Swift Dzire is perfect for daily commuting, city tours, corporate travel, and budget-friendly long-distance journeys for up to 4 passengers.',
    },
    {
        question: 'Is Swift Dzire available for hourly and full-day rentals?',
        answer: 'Yes, you can rent a Swift Dzire by the hour or opt for full-day rental packages, depending on your travel duration and destination.',
    },
    {
        question: 'What is the fare for renting a Swift Dzire in Pune?',
        answer: 'Rental fares start at ₹10–11/km for outstation and vary for local use. Contact us for hourly, full-day, or customized rental quotes.',
    },
    {
        question: 'Are Swift Dzire cabs safe and hygienic?',
        answer: 'Absolutely! Our Swift Dzire cars are well-maintained, sanitized before every trip, and driven by professional, background-verified drivers.',
    },
    {
        question: 'Can I book a Swift Dzire for Pune airport transfers?',
        answer: 'Yes, Prince Cabs provides punctual Swift Dzire cabs for airport drop and pickup services across Pune at affordable prices.',
    },
    {
        question: 'How do I book a Swift Dzire on rent in Pune?',
        answer: 'Booking is easy—just visit our website or call our customer support to reserve your Swift Dzire with your preferred time, location, and route.',
    },
];

const testimonials = [
    {
        name: "Mr. Nitin Jadhav",
        position: "Student",
        text: "Booked a Swift Dzire from Prince Cabs for a weekend trip. The car was in great condition and the driver was polite. Smooth experience!",
        image: "/img/testimonial/testimonial-thumb-dzire-1.png",
    },
    {
        name: "Mrs. Rupa Kamat",
        position: "Working Professional",
        text: "Prince Cabs provided a clean Swift Dzire for my airport transfer in Pune. On-time service and professional driver. Will book again!",
        image: "/img/testimonial/testimonial-thumb-dzire-2.png",
    },
];






























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Swift Dzire on Rent Pune",
  "description": "Swift Dzire car rental in Pune offering affordable and luxury options with per km and per day rates. Ideal for outstation trips like Pune to Mumbai, Mahabaleshwar, and Shirdi.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Swift Dzire Rent per km Rate",
    "Swift Dzire Rent per Day",
    "Swift Dzire Car Rental",
    "Book Swift Dzire Cab in Pune",
    "Pune to Mumbai Dzire Cab",
    "Pune to Mahabaleshwar Swift Dzire Cab",
    "Pune to Shirdi Swift Dzire Taxi",
    "Dzire Car Hire for Outstation Pune",
    "Affordable Swift Dzire Cab",
    "Luxury Dzire Cab Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Swift Dzire on Rent Pune | Affordable & Luxury Dzire Cab Service</title>
  <meta
    name="description"
    content="Swift Dzire car rental in Pune offering affordable and luxury options with per km and per day rates. Ideal for outstation trips like Pune to Mumbai, Mahabaleshwar, and Shirdi."
  />
  <meta
    name="keywords"
    content="Swift Dzire Rent per km Rate, Swift Car Rent per km, Swift Dzire Rent per Day, Swift per km Rate, Swift Rent per km, Swift Dzire for Rent, Swift Dzire Car Rental, Swift Dzire Rent Near Me, Book a Swift Dzire Cab in Pune, Pune to Mumbai Dzire Cab, Pune to Mahabaleshwar Swift Dzire Cab, Pune to Shirdi Swift Dzire Taxi, Dzire Car Hire for Outstation Pune, Affordable Swift Dzire Cab, Luxury Dzire Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Swiftdzireonrentpune ;